import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=b425f730"
import script from "./SidePanel.vue?vue&type=script&lang=ts"
export * from "./SidePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports